import styled from 'styled-components';
import EmailOtp from '../../assets/onboarding/email.svg';

const EmailOtpIcon = styled(EmailOtp as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.2rem'};
height: ${props => props.height || '1.4rem'};
display: flex;
`;

export default EmailOtpIcon;
